import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from "react";
import { setCookie, getCookie, hasCookie, deleteCookie, getCookies } from 'cookies-next';
import { AllMeta } from "../../components/seo/meta";
import { useRouter } from "next/router";
import { Link } from "@/helpers/common_helper";
import { pagelink } from "@/config/site";
import { _postURL } from "@/api/index";
import { toast } from "@/libraries/swal";
import _ from 'lodash';
import Subscription from "@/components/section/subscription";
import CompanyVotingList from '@/components/list/review-voting';
import { Breadcrumb } from '../../components/section/breadcrumb';
import { BsExclamationCircle } from "react-icons/bs";
import { TfiClose } from "react-icons/tfi";
import { useMediaQuery, useScrollLock, useWindowScroll } from '@mantine/hooks';
import { LoadingOverlay, Modal } from '@mantine/core';
import { motion } from 'framer-motion';

export default function Index(props) {
    const { t, session } = props;
    const router = useRouter();
    const [userLogin, setUserLogin] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [offset, setOffset] = useState(0);
    const [totalRow, setTotalRow] = useState(0);
    const [loadMore, setLoadMore] = useState(true);
    const [opened, setOpened] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(0);
    const [selectedAmount, setSelectedAmount] = useState(-1);
    const [openedHowToVote, setOpenedHowToVote] = useState(false);
    const [submitTextChange, setSubmitTextChange] = useState(false);
    const [availableDiamond, setAvailableDiamond] = useState(0);
    const [isProcessing, setIsProcessing] = useState(true);
    const [ scroll, scrollTo ] = useWindowScroll();
    const [ scrollLocked, setScrollLocked ] = useScrollLock(true);
    const voteAmountDiamond = [
        5,10,50,100,500,1000,2000
    ]

    const limit = 10;

    const isMobileView = useMediaQuery('(max-width:1199px)');
    const isSmallView = useMediaQuery('(max-width:399px)');

    const currentPage = {
        pageName: t('Vote_ranking'),
        pageLink: pagelink.review.vote
    };

    const previousPage = [{
        pageName: t('Review'),
        pageLink: pagelink.review.homepage
    }];

    const _castVote = async (company_id, amount) => {
        let memberData = (session && session.user != null) ? session.user.member : '';
        try {
            let req = {
                "user_id" : !_.isEmpty(memberData.member_id) ? memberData.member_id: 0,
                "company_id": company_id,
                "amount": amount
            }
            let result = await _postURL("/api/user/submitVote", {...req});
            if(!_.isEmpty(result.data)){
                toast.success(result.message, true);
                let userData = result.data;
                setCookie('user', JSON.stringify({ ['member']: userData }), { maxAge: "21600" });
                
                // reload after 2 seconds
                setTimeout(function(){
                    window.location = location.pathname;
                }, 2000);
            }
            else{
                toast.error(result.message);
            }
        }
        catch (error) {
            toast.error(error);
        }
    }

    const _getNextVotingList = async (offset, limit = limit) => {
        setIsProcessing(true);
        setScrollLocked(true);
        setOffset(offset);
        let req = {
            "limit": 10,
            "offset": offset
        }
        let result = await _postURL("/api/review/getVoteList", {...req});
        if(offset < totalRow){
            setLoadMore(false);
        }
        setCompanyList([...companyList, ...result.data.data]);
        setIsProcessing(false);
        setScrollLocked(false);
    }

    const _confirmSubmitRank =  async ({companyId, diamondAmount}) => {
        setSubmitTextChange(true);
        if(userLogin){
            let memberData = (session && session.user != null) ? session.user.member : '';
            if(diamondAmount != -1){
                // Proceed
                if(availableDiamond < diamondAmount){
                    toast.error("Please topup to vote");
                }
                else{
                    let req = {
                        "user_id" : !_.isEmpty(memberData.member_id) ? memberData.member_id: 0,
                        "company_id": parseInt(companyId),
                        "amount": diamondAmount
                    }
                    let result = await _postURL("/api/user/submitVote", {...req});
                    if(!_.isEmpty(result.data)){
                        toast.success(result.message, true);
                        let userData = result.data;
                        setCookie('user', JSON.stringify({ ['member']: userData }), { maxAge: "21600" });
                        
                        // reload after 2 seconds
                        setTimeout(function(){
                            window.location = location.pathname;
                        }, 2000);
                    }
                    else{
                        toast.error(result.message);
                    }
                }
            }
            else{
                toast.error("Please select diamond amount");
            }

        }
        else{
            // Redirect to Login
            window.location = pagelink.authentication.login;
        }
    }

    useEffect(async () => {
        let memberData = (session && session.user != null) ? session.user.member : '';
        // console.log(memberData);
        if(!_.isEmpty(memberData)){
            setUserLogin(true);
            setAvailableDiamond(Number(memberData.available_diamond).toFixed(0));
        }

        // fetch data
        let req = {
            "limit": 10,
            "offset": 0
        }
        let result = await _postURL("/api/review/getVoteList", {...req});
        setTotalRow(result.data.total_row);
        setCompanyList(result.data.data);
        setIsProcessing(false);
        setScrollLocked(false);
    }, []);

    // useEffect(async () => {
    //     await _getNextVotingList(offset + limit);
    // }, [])

    return (
        <>
            <AllMeta
                title={t('Vote_ranking')}
                description={''}
                keyword={''}
                currentPageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${router.asPath}`}
                image={''}
            >
                <title>{t('Vote_ranking')}</title>
            </AllMeta>

            <div className="page-content">
                <div className='pt-5'>
                    <div className='custom_container2'>
                        <Breadcrumb 
                            props={ props }
                            currentPage={ currentPage }
                            previousPage={ previousPage }
                        />
                        <div className="general-box">
                            <h1>{t('Vote')}</h1>
                            <p>The {t('Site_name')} Popularity Ranking is based on the {t('Site_name')} popularity vote. Registered {t('Site_name')} users 
                                can top up Diamond to vote for their online casinos; the highest voted sites will be announced in 
                                the ranking board. Don't forget to vote for your favourites <Link href={pagelink.review.vote}><strong className='custom_colorPrimary text-decoration-underline'>here.</strong></Link>
                            </p>
                        </div>
                        <div className='vote-ranking-whatisdiamond'>
                            <div className='d-flex align-items-center'>
                                <h2 className='custom_h2 d-flex align-items-center'>
                                    {t('What_is_diamond')}
                                    <span className='custom_title_icon_size ms-2'>
                                        <img src="/assets/images/diamond-user.svg" alt="" className="img-fluid w-100" />
                                    </span>
                                </h2>
                            </div>
                            <p className='custom_p'>{t('Site_name')} Diamond is an upcoming feature that can be used to vote for one's favorite site, the highest the vote will be featured on the {t('Site_name')} Popularity Board.  Diamond can also be obtained by completing certain tasks, you can 
                                also get it <Link href={pagelink.review.vote}><strong className='custom_colorPrimary text-decoration-underline'>here.</strong></Link>
                            </p>
                        </div>
                    </div>
                    <section className='vote-ranking-diamondRankingBoard custom_container2'>
                        <div className='vote-ranking-diamondRankingBoard-title'>
                            <div className='vote-ranking-diamondRankingBoard-title-image'>
                                <img src="/assets/images/vote-ranking-badge.png" alt="" className="img-fluid w-100" />
                            </div>
                            {isSmallView == true ? 
                                <>
                                    <h2 className='custom_h2'>
                                        Diamond Ranking
                                    </h2>
                                    <div className='d-flex align-items-center'>
                                        <h2 className='custom_h2'>
                                            Board
                                        </h2>
                                        <BsExclamationCircle onClick={()=>{setOpenedHowToVote(true)}} className='vote-ranking-diamondRankingBoard-title-icon' />
                                    </div>
                                </>
                            :
                                <div className='d-flex align-items-center'>
                                    <h2 className='custom_h2'>{t('Diamond_ranking_board')}</h2>
                                    <BsExclamationCircle onClick={()=>{setOpenedHowToVote(true)}} className='vote-ranking-diamondRankingBoard-title-icon' />
                                </div>
                            }
                        </div>
                        <div className='vote-ranking-diamondRankingBoard-board'>
                            <LoadingOverlay visible={isProcessing} overlayBlur={1} className='vh-100 position-absolute' style={{ top: scroll.y }}/>
                            {isMobileView == false &&
                            <div className='d-flex align-items-center position-relative'>
                                <div className='vote-ranking-diamondRankingBoard-board-column'>
                                    <h4 className='custom_h4'>{t('Rank')}</h4>
                                </div>
                                <div className='vote-ranking-diamondRankingBoard-board-column'>
                                    <h4 className='custom_h4'>{t('Casino')}</h4>
                                </div>
                                <div className='vote-ranking-diamondRankingBoard-board-column'>
                                    <h4 className='custom_h4'>{t('Diamonds_held')}</h4>
                                </div>
                                <div className='vote-ranking-diamondRankingBoard-board-column'>
                                    <h4 className='custom_h4'>{t('Vote')}</h4>
                                </div>
                            </div>
                            }
                            <div className='vote-ranking-diamondRankingBoard-board-list'>
                                {
                                    _.reduce(companyList, (result, value, key) => {
                                        result.push(
                                            <CompanyVotingList 
                                                key={key} 
                                                t={t}
                                                value={value} 
                                                rank={1 + key} 
                                                selfWalletDiamond={availableDiamond} 
                                                _confirmSubmitRank={_confirmSubmitRank}
                                                isMobileView={isMobileView} 
                                                setOpened={setOpened}
                                                selectedCompany={selectedCompany}
                                                setSelectedCompany={setSelectedCompany}
                                                selectedAmount={selectedAmount}
                                                setSelectedAmount={setSelectedAmount}
                                                submitTextChange={submitTextChange}
                                                setSubmitTextChange={setSubmitTextChange}
                                                voteAmountDiamond={voteAmountDiamond}
                                            />
                                        )

                                        // rebind tooltips event handler after row had returned
                                        tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                                        tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl))

                                        return result;
                                    }, [])
                                }
                            </div>
                        </div>
                        <div className='mt-5'>
                            <div className="more-history" style={{ display: loadMore ? '' : 'none' }}>
                                <a onClick={() => { _getNextVotingList(offset + limit) }} style={{ cursor: 'pointer' }}>
                                    <img src="/assets/images/double-down-arrow.png" alt="" className="img-fluid" />{t('Load_more')}
                                </a>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                withCloseButton={false}
            >
                <div className='position-relative d-flex align-items-center justify-content-center'>
                    <h3 className='custom_h3'>{t('Select_diamond')}</h3>
                    <div className='vote-ranking-diamondRankingBoard-mobile-modal-closeButton-absolute' onClick={() => setOpened(false)}>
                        <TfiClose className='vote-ranking-diamondRankingBoard-mobile-modal-closeButton' />
                    </div>
                </div>
                <div className='vote-ranking-diamondRankingBoard-mobile-modal-voteConfirm'>
                    <div className='d-flex flex-wrap justify-content-center'>
                        {
                            _.reduce(voteAmountDiamond, (result, value, key) => {
                                result.push(
                                    <div 
                                        className={value === selectedAmount ? 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button-active' : 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button'} 
                                        key={key}
                                        onClick={()=>{setSelectedAmount(value), setSubmitTextChange(false)}}
                                    >
                                        <p className='custom_p2'>
                                            <strong>{value}</strong>
                                        </p>
                                    </div>
                                )
                                return result;
                            }, [])
                        }
                        <div 
                            className={availableDiamond === selectedAmount ? 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button-active' : 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button'} 
                            onClick={()=>{setSelectedAmount(availableDiamond), setSubmitTextChange(false)}}
                        >
                            <p className='custom_p2'>
                                <strong>{t('ALL')}</strong>
                            </p>
                        </div>
                    </div>
                    <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-column'>
                        {selectedAmount >= 0 &&
                            <motion.p 
                                className='custom_p2'
                                initial={{opacity: 0, y: '-50px'}}
                                animate={{opacity: 1, y: 0}}
                            >
                                You've {submitTextChange == true ? 'voted' : 'selected'} <strong>{selectedAmount}</strong> diamonds!
                            </motion.p>
                        }
                    </div>
                    {selectedAmount >= 0 &&
                        <motion.div 
                            className='my-2'
                            initial={{opacity: 0, y: '-50px'}}
                            animate={{opacity: 1, y: 0}}
                        >
                            <p className='custom_p3 text-center'>
                                {t('preview')}
                            </p>
                            <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-remainWallet'>
                                <p className='custom_p2'>
                                    <strong>{availableDiamond}</strong>
                                </p>
                                <p className='custom_p3 custom_colorRed'>
                                    <strong>{selectedAmount >= 0 && '-' + selectedAmount}</strong>
                                </p>
                                <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-remainWallet-image'>
                                    <img src="/assets/images/diamond-icon.png" alt="" className="img-fluid w-100" />
                                </div>
                            </div>
                        </motion.div>
                    }
                    <div onClick={()=>{_confirmSubmitRank({companyId: selectedCompany, diamondAmount: selectedAmount})}} className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-confirm-button'>
                        <h3 className='custom_h3 custom_colorWhite'>{t('Confirm')}</h3>
                    </div>
                </div>
            </Modal>
            <Modal
                opened={openedHowToVote}
                onClose={() => setOpenedHowToVote(false)}
                withCloseButton={false}
            >
                <div>
                    <h4 className='custom_h4'>{t("How_to_vote")}</h4>
                    <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-column mt-3'>
                        <div className='d-flex'>
                            <p className='custom_p2'><strong>Step 1.</strong></p>
                            <p className='custom_p2'><strong>Select</strong> your preferred diamond.</p>
                        </div>
                        <div className='d-flex'>
                            <p className='custom_p2'><strong>Step 2.</strong></p>
                            <p className='custom_p2'>Click <strong>confirm</strong> to vote.</p>
                        </div>
                        <div className='d-flex'>
                            <p className='custom_p2'><strong>Step 3.</strong></p>
                            <p className='custom_p2'>You've succesfully voted for your favorite casino!</p>
                        </div>
                    </div>
                </div>
            </Modal>

            {/** Subscription Part */}
            <Subscription {...props}/>
        </>
    )
}

export async function getStaticProps(data) {
    return {
        props: {
            ...(await serverSideTranslations(data.locale, ['common'])),
        },
    };
}